import { httpClient, ApiResponse } from '@/utils';
import { SeoEndpoints, IUpdateRobotsDTO, IRobotsResponse } from '@/models/seo.model';

class SeoAPI {
  static getRobotsData(): ApiResponse<IRobotsResponse> {
    return httpClient.get<IRobotsResponse>(SeoEndpoints.ROBOTS);
  }

  static updateRobotsData(data: IUpdateRobotsDTO): ApiResponse<IRobotsResponse> {
    return httpClient.put<IRobotsResponse>(SeoEndpoints.ROBOTS_UPDATE, data);
  }
}

export default SeoAPI;
